import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HubConnectionBuilder } from '@microsoft/signalr';
import { config } from '../../shared/config';
import { LoggingService } from '../../shared/services/core/logging.service';
import { AuthService } from '../../user/services/auth.service';
import { SignalRNotificationService } from './signalr-notification.service';
import { SignalRScorecardService } from './signalr-scorecard.service';
import { SignalRAuctionService } from './signalr-auction.service';
import { SignalRFacialRecognitionService } from './signalr-facial-recognition.service';
import { SignalRBaseHub } from './signalr-basehub.service';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SignalRHub extends SignalRBaseHub {
  constructor(
    protected logService: LoggingService,
    protected signalRNotificationService: SignalRNotificationService,
    protected signalRScorecardService: SignalRScorecardService,
    protected signalRAuctionService: SignalRAuctionService,
    protected signalRFacialRecognitionService: SignalRFacialRecognitionService,
    protected authService: AuthService,
    protected jwtHelper: JwtHelperService
  ) {
    super(logService, authService, jwtHelper);

    this.createConnection();
    this.registerOnServerEvents();
    this.startConnection();
  }

  /**
   * Create SignalR connection using token
   */
  private createConnection() {
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(config.baseApiUrl + '/hub', {
        accessTokenFactory: async () => {
          const token = localStorage.getItem('token');
          if (token && this.authService.isAuthenticated() && !this.jwtHelper.isTokenExpired(token)) {
            return token;
          } else if (!token) {
            return '';
          }

          return (await firstValueFrom(this.authService.refreshAccessToken())).AccessToken;
        },
      })
      .build();
  }

  /**
   * Register .on server events
   */
  protected registerOnServerEvents() {
    this.signalRNotificationService.registerOnServerEvents(this.hubConnection);
    this.signalRScorecardService.registerOnServerEvents(this.hubConnection);
    this.signalRAuctionService.registerOnServerEvents(this.hubConnection);
    this.signalRFacialRecognitionService.registerOnServerEvents(this.hubConnection);

    super.registerOnServerEvents();
  }
}
